import { isEmpty } from 'lodash';
import { revertPhoneMask } from 'helpers/revert-phone-mask';
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from './axios.helpers';

export const getAdmin = async (pageNumber, pageSize) =>
  axiosGet(`/users?page[number]=${pageNumber + 1}&page[size]=${pageSize}`);

export const showAdmin = async (id) => axiosGet(`/users/${id}`);

export const updateAdmin = async (id, admin) => {
  const {
    firstName,
    lastName,
    type,
    email,
    phone,
    address,
    city,
    state,
    postalCode,
    country,
    rate,
  } = admin;

  await axiosPatch(`/users/${id}`, {
    first_name: firstName,
    last_name: lastName,
    type,
    email,
    address,
    city,
    state,
    postal_code: postalCode,
    country,
    rate,
    ...(!isEmpty(phone) && { phone: revertPhoneMask(phone) }),
  });
};

export const createAdmin = async (admin) => {
  const {
    firstName,
    lastName,
    email,
    password,
    passwordConfirmation,
    phone,
    address,
    city,
    state,
    postalCode,
    country,
    rate,
  } = admin;

  const submission = {
    first_name: firstName,
    last_name: lastName,
    password,
    password_confirmation: passwordConfirmation,
    email,
    ...(isEmpty(phone) ? {} : { phone: revertPhoneMask(phone) }),
    ...(isEmpty(postalCode) ? {} : { postal_code: postalCode }),
    ...(isEmpty(address) ? {} : { address }),
    ...(isEmpty(city) ? {} : { city }),
    ...(isEmpty(state) ? {} : { state }),
    ...(isEmpty(country) ? {} : { country }),
    ...(isEmpty(rate) ? {} : { rate }),
  };

  await axiosPost('/admin-register', submission);
};

export const deleteAdmin = async (id) => {
  await axiosDelete(`/users/${id}`);
};
